/**
 * True when the SPA is served from the Vedettes de Paris (VDP) CMS origin
 * (see Rewind-react-back-nodejs allowedOrigins / getPrismaClient "vdp").
 */
export function isVdpCmsHost(): boolean {
    if (typeof window === "undefined") return false;
    return window.location.hostname.includes("vedettesdeparis");
}

/**
 * True when the SPA is served from a Rewind "default" database origin
 * (supplier.rewindstories.com, Vercel previews, or localhost).
 */
export function isRewindDefaultHost(): boolean {
    if (typeof window === "undefined") return false;
    const hostname = window.location.hostname;
    return hostname === "localhost" || hostname.includes("supplier.rewindstories") || hostname.includes("rewind-react");
}
